module.exports = __webpack_public_path__ + "media/src/images/step1-e666a1d28422830d44199df301acc422.png";